export const DB_NAME = "SketchDB";
export enum DBNames {
  storage = "storage",
  sketches = "sketches",
}
export const STORAGE_KEY = "STORAGE_KEY";
